import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import {
    DASHBOARD_ROUTE,
    FREE_TRIAL_ROUTE,
    HOME_ROUTE,
    LOGIN_ROUTE,
    QICK_APP_LOGIN_URL,
    QICK_APP_REGISTER_URL,
    QICK_APP_URL,
} from "@/lib/routes";
import Dashboard from "@/pages/Dashboard";
import Landing from "@/pages/Landing";

const ExternalRedirect = ({ to, label }) => {
    useEffect(() => {
        window.location.replace(to);
    }, [to]);

    return (
        <main className="flex min-h-screen items-center justify-center bg-[#F8FAFC] px-4 text-slate-700">
            <div className="rounded-2xl border border-slate-200 bg-white px-5 py-4 text-sm font-semibold shadow-sm">
                Je wordt doorgestuurd naar {label}...
            </div>
        </main>
    );
};

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path={HOME_ROUTE} element={<Landing />} />
                    <Route path={LOGIN_ROUTE} element={<ExternalRedirect to={QICK_APP_LOGIN_URL} label="inloggen" />} />
                    <Route path={FREE_TRIAL_ROUTE} element={<ExternalRedirect to={QICK_APP_REGISTER_URL} label="registreren" />} />
                    <Route path="/signup" element={<ExternalRedirect to={QICK_APP_REGISTER_URL} label="registreren" />} />
                    <Route path="/app" element={<ExternalRedirect to={QICK_APP_URL} label="QICK!" />} />
                    <Route
                        path={DASHBOARD_ROUTE}
                        element={
                            <ProtectedRoute>
                                <Dashboard />
                            </ProtectedRoute>
                        }
                    />
                </Routes>
            </BrowserRouter>
            <Toaster
                position="top-right"
                richColors
                closeButton
                toastOptions={{
                    style: { fontFamily: "Manrope, sans-serif" },
                }}
            />
        </div>
    );
}

export default App;
